<template>
  <nav class="menu-container">
    <h3><font color="#1E22AA">16号线</font></h3>
    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
  </nav>
</template>

<script>
import Icon from "@/components/Icon";
export default {
  components: {
    Icon,
  },
  data() {
    return {
      items: [
        {
          //大运站有3个不同信息，，一个在3号dayun.一个在14号dayun2，另一个在16号,dayun3.
          name: "dayun3",
          title: "大运",
          // icon: "chat",
          exact: true,
        },
        {
          name: "dayunzhongxin",
          title: "大运中心",
          // icon: "chat",
          exact: true,
        },
        {
          name: "longchenggongyuan",
          title: "龙城公园",
          // icon: "chat",
          exact: true,
        },
        {
          name: "huanggekeng",
          title: "黄阁坑",
          // icon: "chat",
          exact: true,
        },
        {
          name: "yuyuan",
          title: "愉园",
          // icon: "chat",
          exact: true,
        },
        {
          name: "huilongpu",
          title: "回龙埔",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shangjing",
          title: "尚景",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shengping",
          title: "盛平",
          // icon: "chat",
          exact: true,
        },
        {
          name: "longyuan",
          title: "龙园",
          // icon: "chat",
          exact: true,
        },
        {
          //双龙 shuanglong有2个不同信息，，一个在3号shuanglong.一个在16号shuanglong2
          name: "shuanglong2",
          title: "双龙",
          // icon: "chat",
          exact: true,
        },
        {
          name: "xintangwei",
          title: "新塘围",
          // icon: "chat",
          exact: true,
        },
        {
          name: "longdong",
          title: "龙东",
          // icon: "chat",
          exact: true,
        },
        {
          name: "baolongtongle",
          title: "宝龙同乐",
          // icon: "chat",
          exact: true,
        },
        {
          name: "pingshan",
          title: "坪山",
          // icon: "chat",
          exact: true,
        },
        {
          name: "xinhe",
          title: "新和",
          // icon: "chat",
          exact: true,
        },
        {
          name: "liuhe",
          title: "六和",
          // icon: "chat",
          exact: true,
        },
        {
          //坪山围站有2个不同信息，，一个在14号pingshanwei.一个在16号pingshanwei2
          name: "pingshanwei2",
          title: "坪山围",
          // icon: "chat",
          exact: true,
        },
        {
          name: "pinghuan",
          title: "坪环",
          // icon: "chat",
          exact: true,
        },
        {
          name: "dongzongjinianguan",
          title: "东纵纪念馆",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shabo",
          title: "沙壆",
          // icon: "chat",
          exact: true,
        },
        {
          name: "yanzihu",
          title: "燕子湖",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shijing",
          title: "石井",
          // icon: "chat",
          exact: true,
        },
        {
          name: "jishudaxue",
          title: "技术大学",
          // icon: "chat",
          exact: true,
        },
        {
          name: "tianxin",
          title: "田心",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(67, 47, 221);
    }
  }
}
</style>





<!-- <template>
  <div>
    <h3>
        首页<br><br>
深圳地铁1号线 途经站点 共30站<br><br>
注：高峰期发车间隔为4分钟，平峰期为6分钟<br><br>

罗湖站-国贸站-老街站-大剧院站-科学馆站-华强路站-岗厦站-会展中心站-购物公园站-香蜜湖站-车公庙站-竹子林站-侨城东站-华侨城站-世界之窗站-白石洲站-高新园站-深大站-桃园站-大新站-鲤鱼门站-前海湾站-新安站-宝安中心站- 宝体站-坪洲站-西乡站-固戍站-后瑞站-机场东站
    </h3>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style> -->